import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/login/Login'
import LoginSuper from '@/components/login/Login'
import EnableTwoFactorAuthentication from '@/components/login/EnableTwoFactorAuthentication'
import ResetPassword from '@/components/login/ResetPassword'
import RecoverConfirmCode from '@/components/login/RecoverConfirmCode'

import Dashboard from '@/components/dashboard/Dashboard'

const SearchOrder			= () => import(/* webpackChunkName: "searchorder" */		'@/components/dashboard/SearchOrder');
const UpdateInformation		= () => import(/* webpackChunkName: "UpdateInformation" */	'@/components/dashboard/Account');
const AccountEmail			= () => import(/* webpackChunkName: "AccountEmail" */		'@/components/dashboard/AccountEmail');
const AccountConfig			= () => import(/* webpackChunkName: "AccountConfig" */		'@/components/dashboard/AccountConfig');
const AccountFee			= () => import(/* webpackChunkName: "AccountFee" */			'@/components/dashboard/AccountFee');
const AccountProduct		= () => import(/* webpackChunkName: "AccountProduct" */		'@/components/dashboard/AccountProduct');
const AccountUserConfig		= () => import(/* webpackChunkName: "AccountUserConfig" */	'@/components/dashboard/AccountUserConfig');
const AccountUserList		= () => import(/* webpackChunkName: "AccountUserList" */	'@/components/dashboard/AccountUserList');
const AccountWebhook		= () => import(/* webpackChunkName: "AccountWebhook" */		'@/components/dashboard/AccountWebhook');
const SettlementReport		= () => import(/* webpackChunkName: "SettlementReport" */	'@/components/dashboard/SettlementReport');
const SettlementReportGateway = () => import(/* webpackChunkName: "SettlementReportGateway" */	'@/components/dashboard/SettlementReportGateway');
const SalesReport			= () => import(/* webpackChunkName: "SalesReport" */		'@/components/dashboard/SalesReport');
const CommissionReport		= () => import(/* webpackChunkName: "CommissionReport" */	'@/components/dashboard/CommissionReport');
const GraphicReport			= () => import(/* webpackChunkName: "GraphicReport" */		'@/components/dashboard/GraphicReport');
const RefundReport			= () => import(/* webpackChunkName: "RefundReport" */		'@/components/dashboard/RefundReport');
const Resource				= () => import(/* webpackChunkName: "Resource" */			'@/components/dashboard/Resource');
const OfflinePayment		= () => import(/* webpackChunkName: "OfflinePayment" */		'@/components/dashboard/OfflinePayment');
const SearchOfflinePayment	= () => import(/* webpackChunkName: "SearchOfflinePayment" */ '@/components/dashboard/SearchOfflinePayment');
const Favorecido			= () => import(/* webpackChunkName: "Favorecido" */			'@/components/dashboard/Favorecido');
const News					= () => import(/* webpackChunkName: "News" */				'@/components/dashboard/News');
const PagShield				= () => import(/* webpackChunkName: "PagShield" */			'@/components/dashboard/PagShield');
const AccountPayout			= () => import(/* webpackChunkName: "AccountPayout" */		'@/components/dashboard/AccountPayout');
const Payee					= () => import(/* webpackChunkName: "Payee" */				'@/components/dashboard/Payout/Payout_Payee');
const Payout				= () => import(/* webpackChunkName: "Payout" */				'@/components/dashboard/Payout/Payout_Payout');
const PayoutMovement		= () => import(/* webpackChunkName: "PayoutMovement" */		'@/components/dashboard/Payout/Payout_Movement');
const WebhookHistory		= () => import(/* webpackChunkName: "WebhookHistory" */		'@/components/dashboard/WebhookHistory');
const IpnHistory			= () => import(/* webpackChunkName: "IpnHistory" */			'@/components/dashboard/IpnHistory');
const IPN					= () => import(/* webpackChunkName: "IPN" */				'@/components/dashboard/IPN');
const PODReport				= () => import(/* webpackChunkName: "PODReport" */			'@/components/dashboard/PODReport');
const UnidadeRecebivel		= () => import(/* webpackChunkName: "UnidadeRecebivel" */	'@/components/dashboard/UnidadeRecebivel');
const PosContratada			= () => import(/* webpackChunkName: "PosContratada" */		'@/components/dashboard/PosContratada');
const EfeitoContrato		= () => import(/* webpackChunkName: "EfeitoContrato" */		'@/components/dashboard/EfeitoContrato');
const PagShieldDecisionList	= () => import(/* webpackChunkName: "PagShieldDecisionList" */ '@/components/dashboard/PagShieldDecisionList');

/* PagStream */
const PagStreamReport			= () => import(/* webpackChunkName: "PagStreamReport" */		'@/components/dashboard/PagStream/Report');
const PagStreamSetting			= () => import(/* webpackChunkName: "PagStreamSetting" */		'@/components/dashboard/PagStream/Setting');
const PagStreamProduct			= () => import(/* webpackChunkName: "PagStreamProduct" */		'@/components/dashboard/PagStream/Product');
const PagStreamOverview			= () => import(/* webpackChunkName: "PagStreamOverview" */		'@/components/dashboard/PagStream/Overview');
const PagStreamCustomerArea		= () => import(/* webpackChunkName: "PagStreamCustomerArea" */	'@/components/dashboard/PagStream/CustomerArea');
const PagStreamBillingCycle		= () => import(/* webpackChunkName: "PagStreamBillingCycle" */	'@/components/dashboard/PagStream/BillingCycle');
const PagStreamShippingCycle	= () => import(/* webpackChunkName: "PagStreamShippingCycle" */	'@/components/dashboard/PagStream/ShippingCycle');
const PagStreamNotification		= () => import(/* webpackChunkName: "PagStreamNotification" */	'@/components/dashboard/PagStream/Notification');
const PagStreamPromotion		= () => import(/* webpackChunkName: "PagStreamPromotion" */		'@/components/dashboard/PagStream/Promotion');
const PagStreamAutomation		= () => import(/* webpackChunkName: "PagStreamAutomation" */	'@/components/dashboard/PagStream/Automation');
const PagStreamSubscription		= () => import(/* webpackChunkName: "PagStreamSubscription" */	'@/components/dashboard/PagStream/Subscription');

const Gateway				= () => import(/* webpackChunkName: "Gateway" */				'@/components/dashboard/Gateway');
const PagShieldReport		= () => import(/* webpackChunkName: "PagShieldReport" */		'@/components/dashboard/PagShieldReport');
const RemittanceSchedule	= () => import(/* webpackChunkName: "RemittanceSchedule" */		'@/components/dashboard/RemittanceSchedule');
const RemitAnticipation		= () => import(/* webpackChunkName: "RemitAnticipation" */		'@/components/dashboard/RemittanceAnticipation');
const CatalogoCategoria		= () => import(/* webpackChunkName: "CatalogoCategoria" */		'@/components/dashboard/CatalogoCategoria');
const CatalogoProduto		= () => import(/* webpackChunkName: "CatalogoProduto" */		'@/components/dashboard/CatalogoProduto');
const UpdateOrder			= () => import(/* webpackChunkName: "UpdateOrder" */			'@/components/dashboard/UpdateOrder');
const AccountShopify		= () => import(/* webpackChunkName: "Remittance" */ 			'@/components/dashboard/AccountShopify');
const Overviews				= () => import(/* webpackChunkName: "Overviews" */				'@/components/dashboard/Overviews/Overview');
const Payment				= () => import(/* webpackChunkName: "Payment" */ 				'@/components/dashboard/Payment/Payment');
const PaymentSetting		= () => import(/* webpackChunkName: "PaymentSetting" */ 		'@/components/dashboard/AccountPayment');
const PaymentSettingConfig	= () => import(/* webpackChunkName: "PaymentSettingConfig" */ 	'@/components/dashboard/AccountPaymentConfig');
const BlocklistRoaming		= () => import(/* webpackChunkName: "BlocklistRoaming" */		'@/components/dashboard/Payment/BlocklistPixRoaming');
const PaymentReport			= () => import(/* webpackChunkName: "PaymentReport" */ 			'@/components/dashboard/Payment/Report');
const PaymentRemittance		= () => import(/* webpackChunkName: "PaymentRemittance" */ 		'@/components/dashboard/Payment/Remittance');
const PaymentInvoice		= () => import(/* webpackChunkName: "PaymentInvoice" */ 		'@/components/dashboard/Payment/Invoice');
const PaymentControlBlock	= () => import(/* webpackChunkName: "PaymentControlBlock" */ 	'@/components/dashboard/Payment/AccountPaymentControlBlock');
const PaymentControlBlockByMcc	= () => import(/* webpackChunkName: "PaymentControlBlockByMcc" */ 	'@/components/dashboard/Payment/AccountPaymentControlBlockByMcc');
const PaymentControlBlockList = () => import(/* webpackChunkName: "PaymentControlBlock" */ 	'@/components/dashboard/Payment/PaymentControlBlock');
const SearchTrial			= () => import(/* webpackChunkName: "SearchTrial" */ 			'@/components/dashboard/SearchTrial');

import Super from '@/components/super/Dashboard'
import Overview from '@/components/super/Overview'

const Statistics			= () => import(/* webpackChunkName: "Statistics" */ 			'@/components/super/Statistics');
const StatisticsPayment	  	= () => import(/* webpackChunkName: "StatisticsPayment" */ 		'@/components/super/StatisticsPayment');
const StatsChargebacks		= () => import(/* webpackChunkName: "StatsChargebacks" */ 		'@/components/super/StatsChargebacks');
const StatsDia				= () => import(/* webpackChunkName: "StatsDia" */ 				'@/components/super/StatsDia');
const StatsForecast			= () => import(/* webpackChunkName: "StatsForecast" */ 			'@/components/super/StatsForecast');
const ForecastCompare		= () => import(/* webpackChunkName: "ForecastCompare" */ 		'@/components/super/ForecastCompare');
const StatsTime				= () => import(/* webpackChunkName: "StatsTime" */ 				'@/components/super/StatsTime');
const SuperSettlementReport	= () => import(/* webpackChunkName: "SuperSettlementReport" */ 	'@/components/super/SettlementReport');
const ConsolidatedReport	= () => import(/* webpackChunkName: "ConsolidatedReport" */ 	'@/components/super/ConsolidatedReport');
const PayoutReport			= () => import(/* webpackChunkName: "PayoutReport" */ 			'@/components/super/PayoutReport');
const FeeReport				= () => import(/* webpackChunkName: "FeeReport" */ 				'@/components/super/FeeReport');
const ReserveReport			= () => import(/* webpackChunkName: "ReserveReport" */ 			'@/components/super/ReserveReport');
const RevenueReport			= () => import(/* webpackChunkName: "RevenueReport" */ 			'@/components/super/RevenueReport');
const RevenueGroupRange		= () => import(/* webpackChunkName: "RevenueGroupRange" */		'@/components/super/RevenueGroupRange');
const SuperNews				= () => import(/* webpackChunkName: "SuperNews" */ 				'@/components/super/SuperNews');
const Calendar				= () => import(/* webpackChunkName: "Calendar" */ 				'@/components/super/Calendar');
const Graphic				= () => import(/* webpackChunkName: "Graphic" */ 				'@/components/super/Graphic');
const PixConfig				= () => import(/* webpackChunkName: "PixConfig" */ 				'@/components/super/PixConfig');
const PixAutomaticoConfig	= () => import(/* webpackChunkName: "PixAutomaticoConfig" */	'@/components/super/PixAutomaticoConfig');
const RabbitMQQueue			= () => import(/* webpackChunkName: "RabbitMQQueue" */ 			'@/components/super/RabbitMQQueue');
const BlocklistPixRoaming	= () => import(/* webpackChunkName: "BlocklistPixRoaming" */	'@/components/super/BlocklistPixRoaming');
const NotaFiscal			= () => import(/* webpackChunkName: "NotaFiscal" */ 			'@/components/super/SuperNotaFiscal');
const NotaFiscalMarkup		= () => import(/* webpackChunkName: "NotaFiscalMarkup" */		'@/components/super/SuperNotaFiscalMarkup');
const GrupoPermissao		= () => import(/* webpackChunkName: "GrupoPermissao" */ 		'@/components/super/GrupoPermissao');
const Usuario				= () => import(/* webpackChunkName: "Usuario" */ 				'@/components/super/Usuario');
const Permissao				= () => import(/* webpackChunkName: "Permissao" */ 				'@/components/super/Permissao');
const PermissaoEspecial		= () => import(/* webpackChunkName: "PermissaoEspecial" */ 		'@/components/super/PermissaoEspecial');
const PermissaoMerchant		= () => import(/* webpackChunkName: "PermissaoMerchant" */ 		'@/components/super/PermissaoMerchant');
const PermissaoCampo		= () => import(/* webpackChunkName: "PermissaoCampo" */ 		'@/components/super/PermissaoCampo');
const SuperAccount			= () => import(/* webpackChunkName: "SuperAccount" */ 			'@/components/super/SuperAccount');
const SuperAccountEstabCom	= () => import(/* webpackChunkName: "SuperAccountEstabCom" */	'@/components/super/SuperAccountEstabComercial');
const SuperAccountGroup		= () => import(/* webpackChunkName: "SuperAccountGroup" */ 		'@/components/super/SuperAccountGroup');
const SuperAccountUser		= () => import(/* webpackChunkName: "SuperAccountUser" */ 		'@/components/super/SuperAccountUser');
const SuperConfig			= () => import(/* webpackChunkName: "SuperConfig" */ 			'@/components/super/SuperConfig');
const SuperPODReport		= () => import(/* webpackChunkName: "SuperPODReport" */ 		'@/components/super/SuperPODReport');
const SuperUnidadeRecebivel	= () => import(/* webpackChunkName: "SuperUnidadeRecebivel" */	'@/components/super/UnidadeRecebivel');
const RemittanceReport		= () => import(/* webpackChunkName: "RemittanceReport" */ 		'@/components/super/remittance/RemittanceReport');
const FeeRemittance			= () => import(/* webpackChunkName: "FeeRemittance" */			'@/components/super/remittance/FeeRemittance');
const Remittance			= () => import(/* webpackChunkName: "Remittance" */ 			'@/components/super/remittance/Remittance');
const Proforma				= () => import(/* webpackChunkName: "Proforma" */ 				'@/components/super/remittance/Proforma');
const ProformaPayment		= () => import(/* webpackChunkName: "ProformaPayment" */		'@/components/super/remittance/ProformaPayment');
const ConsolidateTaxId		= () => import(/* webpackChunkName: "ConsolidateTaxId" */		'@/components/super/remittance/ConsolidateTaxId');
const Invoice				= () => import(/* webpackChunkName: "Invoice" */				'@/components/super/remittance/Invoice');
const Processment			= () => import(/* webpackChunkName: "Processment" */			'@/components/super/remittance/Processment');
const InvoicePayment		= () => import(/* webpackChunkName: "InvoicePayment" */			'@/components/super/remittance/InvoicePayment');
const SuperAccountRevenue 	= () => import(/* webpackChunkName: "SuperAccountRevenue" */	'@/components/super/SuperAccountRevenueGroup');
const SuperFeesConfig	 	= () => import(/* webpackChunkName: "SuperFeesConfig" */		'@/components/super/SuperProcessFees');
const ConfiguracaoCusto		= () => import(/* webpackChunkName: "ConfiguracaoCusto" */		'@/components/super/ConfiguracaoCusto');
const FullPaymentRemittance	= () => import(/* webpackChunkName: "FullPaymentRemittance" */	'@/components/super/FullPaymentRemittance');
const ModeloContrato		= () => import(/* webpackChunkName: "ModeloContrato" */			'@/components/super/ModeloContrato');
const SuperMerchantsPagShieldDecisionList	= () => import(/* webpackChunkName: "SuperMerchantsPagShieldDecisionList" */ '@/components/super/SuperMerchantsPagShieldDecisionList');
const SuperGlobalMerchantPagShieldDecisionList	= () => import(/* webpackChunkName: "SuperGlobalMerchantPagShieldDecisionList" */ '@/components/super/SuperGlobalMerchantPagShieldDecisionList');
const ConnectorProcessor			= () => import(/* webpackChunkName: "ConnectorProcessor" */			'@/components/super/ConnectorProcessor');
const ConnectorProcessorMerchant	= () => import(/* webpackChunkName: "ConnectorProcessorMerchant" */	'@/components/super/ConnectorProcessorMerchant');

Vue.use(Router)

export default new Router({
	routes: [
		{
			path: '/',
			component: Login
		},

		{
			path: '/login',
			name: 'Login',
			component: Login
		},

		{
			path: '/login_first',
			name: 'LoginFirst',
			component: Login,
		},

		{
			path: '/login_super',
			name: 'LoginSuper',
			component: LoginSuper
		},

		{
			path: '/login_first_super',
			name: 'LoginFirstSuper',
			component: Login,
		},

		{
			path: '/two_factor_authentication',
			name: 'EnableTwoFactorAuthentication',
			component: EnableTwoFactorAuthentication
		},

		{
			path: '/reset_password',
			name: 'ResetPassword',
			component: ResetPassword
		},

		{
			path: '/confirm_code',
			name: 'RecoverConfirmCode',
			component:	RecoverConfirmCode

		},

		{
			path: '/super/',
			component: Super,
			children:[
				{path: '', 							name: 'Super', 		component: Overview},
				{path: '/overview',					component: Overview},
				{path: '/statistics',				component: Statistics},
				{path: '/statisticspayment',		component: StatisticsPayment},
				{path: '/statschargebacks',			component: StatsChargebacks},
				{path: '/statsdia',					component: StatsDia},
				{path: '/statsforecast',			component: StatsForecast},
				{path: '/forecastcompare',			component: ForecastCompare},
				{path: '/statstime',				component: StatsTime},
				{path: '/reportsettlement',			component: SuperSettlementReport},
				{path: '/reportconsolidated',		component: ConsolidatedReport},
				{path: '/reportpayout',				component: PayoutReport},
				{path: '/reportfee',				component: FeeReport},
				{path: '/reportreserve',			component: ReserveReport},
				{path: '/reportrevenue',			component: RevenueReport},
				{path: '/revenuegrouprange',		component: RevenueGroupRange},
				{path: '/supernews',				component: SuperNews},
				{path: '/calendar',					component: Calendar},
				{path: '/graphic',					component: Graphic},
				{path: '/pixconfig',				component: PixConfig},
				{path: '/pixautomaticoconfig',		component: PixAutomaticoConfig},
				{path: '/rabbitmqqueue',			component: RabbitMQQueue},
				{path: '/blocklistpixroaming',		component: BlocklistPixRoaming},
				{path: '/reportnotafiscal',			component: NotaFiscal},
				{path: '/reportnotafiscalmarkup',	component: NotaFiscalMarkup},
				{path: '/grupopermissao',			component: GrupoPermissao},
				{path: '/usuario',					component: Usuario},
				{path: '/permissao',				component: Permissao},
				{path: '/permissaoespecial',		component: PermissaoEspecial},
				{path: '/permissaomerchant',		component: PermissaoMerchant},
				{path: '/permissaocampo',			component: PermissaoCampo},
				{path: '/resource_super',			component: Resource},
				{path: '/superaccount',				component: SuperAccount},
				{path: '/superaccountestabcom',		component: SuperAccountEstabCom},
				{path: '/superaccountgroup',		component: SuperAccountGroup},
				{path: '/superaccountrevenuegroup',	component: SuperAccountRevenue},
				{path: '/superfeesconfiguration',	component: SuperFeesConfig},
				{path: '/superaccountuser',			component: SuperAccountUser},
				{path: '/superconfig',				component: SuperConfig},
				{path: '/reportpod',				component: SuperPODReport},
				{path: '/recebivelunidade',			component: SuperUnidadeRecebivel},
				{path: '/reportremittance',			component: RemittanceReport},
				{path: '/feeremittance',			component: FeeRemittance},
				{path: '/remittance',				component: Remittance},
				{path: '/proforma',					component: Proforma},
				{path: '/proformapayment',			component: ProformaPayment},
				{path: '/consolidatetaxid',			component: ConsolidateTaxId},
				{path: '/invoice',					component: Invoice},
				{path: '/processment',				component: Processment},
				{path: '/costconfiguration',		component: ConfiguracaoCusto},
				{path: '/fullpaymentremittance',	component: FullPaymentRemittance},
				{path: '/modelocontrato',			component: ModeloContrato},
				{path: '/invoicepayment',			component: InvoicePayment},
				{path: '/connectorprocessor',			component: ConnectorProcessor},
				{path: '/connectorprocessormerchant',	component: ConnectorProcessorMerchant},
				{path: '/pagshield/decision-list-merchants',	component: SuperMerchantsPagShieldDecisionList},
				{path: '/pagshield/decision-list-global',	component: SuperGlobalMerchantPagShieldDecisionList},
			]
		},

		{
			path: '/dashboard/',
			component: Dashboard,
			children:[
				{path: '', 							component: News, 		name: 'Dashboard'},
				{path: '/overviews', 				component: Overviews,	name: 'Overviews'},
				{path: '/searchorder', 				component: SearchOrder, name: 'SearchOrder'},
				{path: '/updateinformation',		component: UpdateInformation},
				{path: '/accountemail',				component: AccountEmail},
				{path: '/accountconfig/:aba',		component: AccountConfig},
				{path: '/accountconfig',			component: AccountConfig},
				{path: '/accountfee',				component: AccountFee},
				{path: '/accountproduct',			component: AccountProduct},
				{path: '/accountuserconfig',		component: AccountUserConfig},
				{path: '/accountuserlist',			component: AccountUserList},
				{path: '/blocklistroaming',			component: BlocklistRoaming},
				{path: '/settlementreport',			component: SettlementReport},
				{path: '/settlementreportgateway',	component: SettlementReportGateway},
				{path: '/salesreport',				component: SalesReport},
				{path: '/commissionreport',			component: CommissionReport},
				{path: '/graphicreport',			component: GraphicReport},
				{path: '/refundreport',				component: RefundReport},
				{path: '/offlinepayment',			component: OfflinePayment, name:'offlinepayment'},
				{path: '/searchofflinepayment', 	component: SearchOfflinePayment},
				{path: '/favorecido',				component: Favorecido},
				{path: '/resource',					component: Resource},
				{path: '/news',						component: News},
				{path: '/pagshield',				component: PagShield},
				{path: '/sp_settings',				component: AccountPayout},
				{path: '/sp_payee',					component: Payee},
				{path: '/sp_payout',				component: Payout},
				{path: '/sp_movement',				component: PayoutMovement},
				{path: '/config_webhook',			component: AccountWebhook},
				{path: '/history_webhook',			component: WebhookHistory},
				{path: '/ipnhistory',				component: IpnHistory},
				{path: '/ipn',						component: IPN},
				{path: '/podreport',				component: PODReport},
				{path: '/unidaderecebivel',			component: UnidadeRecebivel},
				{path: '/poscontratada',			component: PosContratada},
				{path: '/efeitocontrato',			component: EfeitoContrato},
				{path: '/pagshield/decision-list',			component: PagShieldDecisionList},

				/* PagStream */
				{path: '/pagstream/overview',		component: PagStreamOverview		},
				{path: '/pagstream/setting',		component: PagStreamSetting			},
				{path: '/pagstream/product',		component: PagStreamProduct			},
				{path: '/pagstream/customer_area', 	component: PagStreamCustomerArea	},
				{path: '/pagstream/billing_cycle',	component: PagStreamBillingCycle	},
				{path: '/pagstream/shipping_cycle',	component: PagStreamShippingCycle	},
				{path: '/pagstream/notification',	component: PagStreamNotification	},
				{path: '/pagstream/report',			component: PagStreamReport			},
				{path: '/pagstream/promotion',		component: PagStreamPromotion		},
				{path: '/pagstream/automation',		component: PagStreamAutomation		},
				{path: '/pagstream/subscription',	component: PagStreamSubscription	},

				{path: '/gateway',					component: Gateway},
				{path: '/pagshieldreport',			component: PagShieldReport},
				{path: '/remittanceschedule',		component: RemittanceSchedule},
				{path: '/remittanceanticipation',	component: RemitAnticipation},
				{path: '/catalogocategoria',		component: CatalogoCategoria},
				{path: '/catalogoproduto',			component: CatalogoProduto},
				{path: '/accountShopify',			component: AccountShopify},
				{path: '/payment',					component: Payment, name:'Payment'},
				{path: '/payment_setting',			component: PaymentSetting},
				{path: '/payment_control_block',	component: PaymentControlBlock},
				{path: '/payment_control_block_by_mcc',	component: PaymentControlBlockByMcc},
				{path: '/payment_setting_config',	component: PaymentSettingConfig},
				{path: '/payment_report',			component: PaymentReport},
				{path: '/payment_control_block_list', component: PaymentControlBlockList},
				{path: '/payment_remittance',		component: PaymentRemittance},
				{path: '/payment_invoice',			component: PaymentInvoice},
				{path: '/updateorder/:ordernumber', component: UpdateOrder},
				{path: '/updateorder',				component: UpdateOrder, name:'updateorder'},
				{path: '/trial', 					component: SearchTrial},
			]
		},
	]
})
